<template>
  <v-container fluid>
    <v-card flat shaped>
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step
            :complete="e1 > 1"
            step="1"
            color="green"
            class="caption"
            >Basic Details</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step
            color="green"
            class="caption"
            :complete="e1 > 2"
            step="2"
            >Address</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step
            color="green"
            class="caption"
            :complete="e1 > 3"
            step="3"
            >Upload Docs</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step
            color="green"
            class="caption"
            :complete="e1 > 4"
            step="4"
            >First Card Info</v-stepper-step
          >
          <v-divider></v-divider>

          <v-stepper-step
            color="green"
            class="caption"
            step="5"
            :complete="e1 > 5"
            >Bank Information</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step
            color="green"
            class="caption"
            step="6"
            :complete="e1 > 6"
            >Preview</v-stepper-step
          >
          <!-- <v-divider></v-divider>
              <v-stepper-step
                color="green"
                class="caption"
                step="7"
                :complete="e1 > 7"
                >Verification Status</v-stepper-step
              > -->
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form ref="formStep11" lazy-validation>
              <v-row>
                <v-col cols="12" md="6" sm="12" xs="12" lg="6">
                  <v-card-title class="text mt-n5 ml-n2"
                    >Enter Key Person Details</v-card-title
                  >
                  <v-row no-gutters>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12">
                      <v-text-field
                        v-model="getbasicinfo.first_name"
                        label="First Name *"
                        color="primary"
                        :rules="rules.title"
                        maxlength="25"
                        required
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12">
                      <v-text-field
                        v-model="getbasicinfo.middle_name"
                        label="Middle Name"
                        color="primary"
                        maxlength="25"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12">
                      <v-text-field
                        v-model="getbasicinfo.last_name"
                        label="Last Name"
                        color="primary"
                        maxlength="25"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" md="7" sm="12" xs="12" lg="7">
                      <v-text-field
                        v-model="getbasicinfo.designation"
                        label="Designation *"
                        color="primary"
                        :rules="rules.title"
                        maxlength="30"
                        required
                        outlined
                        dense
                        class="mr-1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5" sm="12" xs="12" lg="5">
                      <v-text-field
                        dense
                        placeholder="Mobile Number *"
                        :rules="[
                          (v) => !!v || 'Required',
                          (v) =>
                            /^(?=[a-zA-Z0-9@._%+-]{0,30}$)[0-9 +-]{0,64}$/.test(
                              v
                            ) || 'Invalid',
                          (v) =>
                            (v && v.length < 11) || 'Invalid Contact Number',
                          (v) =>
                            (v && v.length > 8) || 'Invalid Contact Number',
                        ]"
                        maxlength="10"
                        label="Mobile Number"
                        prefix="+60"
                        v-model="getbasicinfo.contact_num"
                        @keypress="isNumber($event)"
                        outlined
                        class="ml-1"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12">
                      <v-text-field
                        outlined
                        dense
                        append-icon="mdi-person"
                        :rules="emailRules"
                        label="E-mail *"
                        v-model="getbasicinfo.email_id"
                        value
                        @keydown.space="preventLeadingSpace"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                </v-col>
                <v-divider light vertical></v-divider>
                <v-col cols="12" md="6" sm="12" xs="12" lg="6">
                  <v-card-title class="text mt-n5 ml-n2"
                    >Enter Company Details</v-card-title
                  >
                  <v-row no-gutters>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12">
                      <v-textarea
                        v-model="getbasicinfo.comp_name"
                        label="Company Name *"
                        color="primary"
                        required
                        dense
                        :rules="rules.title"
                        outlined
                        auto-grow
                        maxlength="100"
                        rows="1"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12">
                      <v-select
                        class="mt-n0"
                        :items="typeofentities"
                        v-model="getbasicinfo.ent_type"
                        :rules="rules.title"
                        label="Type of Entity *"
                        required
                        outlined
                        dense="dense"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12">
                      <v-text-field
                        v-model="getbasicinfo.registration_num"
                        class="mt-n0"
                        label="Company Registration Number *"
                        color="primary"
                        maxlength="15"
                        :rules="[
                          (v) => !!v || 'Required',

                          (v) => v.length >= 4 || 'Mini 4 characters',
                        ]"
                        required
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12">
                      <v-select
                        :items="natureofbusinesses"
                        v-model="getbasicinfo.nat_of_busn"
                        :rules="rules.title"
                        label="Nature of business *"
                        required
                        outlined
                        dense="dense"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>

            <v-row class="mt-n3">
              <v-spacer />

              <v-btn color="primary" @click="stepper1()" class="mr-4"
                >Continue</v-btn
              >
            </v-row>

            <v-card-actions></v-card-actions>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-form ref="formStep2" lazy-validation>
              <v-card height="fit-content" flat>
                <v-row class="pa-0">
                  <v-card-title class="text">Registered Address</v-card-title>
                </v-row>
                <v-row class="mt-n4">
                  <v-col cols="12" md="6" sm="12" xs="12" lg="6" xl="6">
                    <v-textarea
                      v-model="getaddresslist.addressline1"
                      label="Address Line 1 *"
                      outlined
                      auto-grow
                      :rules="rules.title"
                      rows="2"
                      row-height="15"
                      maxlength="100"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" md="6" sm="12" xs="12" lg="6" xl="6">
                    <v-textarea
                      v-model="getaddresslist.addressline2"
                      label="Address Line 2 *"
                      outlined
                      auto-grow
                      :rules="rules.title"
                      rows="2"
                      row-height="15"
                      maxlength="100"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row class="mt-n6">
                  <v-col cols="12" md="3" sm="12" xs="12" lg="3" xl="3">
                    <v-text-field
                      v-model="getaddresslist.city"
                      label="City *"
                      color="primary"
                      :rules="rules.title"
                      required
                      outlined
                      dense
                      maxlength="20"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" xs="12" lg="3" xl="3">
                    <v-select
                      v-model="getaddresslist.state"
                      label="Select State *"
                      :rules="rules.title"
                      color="primary"
                      :items="stateList"
                      item-text="state_name"
                      required
                      outlined
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" xs="12" lg="3" xl="3">
                    <v-text-field
                      v-model="getaddresslist.country"
                      label="Country"
                      :rules="rules.title"
                      color="primary"
                      required
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" xs="12" lg="3" xl="3">
                    <v-text-field
                      v-model="getaddresslist.zip_code"
                      label="Enter Postal Code *"
                      maxlength="5"
                      @keypress="isNumber($event)"
                      color="primary"
                      required
                      outlined
                      dense
                      :rules="[
                        (v) => !!v || 'Required',
                        (v) =>
                          /^(?=[a-zA-Z0-9]{0,16}$)[0-9 +-]{0,16}$/.test(v) ||
                          'Invalid Input',
                        (v) => v.length >= 3 || 'Mini 3 characters',
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-n8 pa-0">
                  <v-card-title class="text">Business Address</v-card-title>
                  <v-col>
                    <v-checkbox
                      class="mt-4"
                      dense
                      v-model="getaddresslist.is_bus_adrs"
                      @click="calladdress"
                      label="Same As Registered Address?"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row v-if="getaddresslist.is_bus_adrs == false" class="mt-n6">
                  <v-col cols="12" md="6" sm="12" xs="12" lg="6" xl="6">
                    <v-textarea
                      v-model="getaddresslistbusins.addressline1"
                      label="Address Line 1 *"
                      outlined
                      auto-grow
                      :rules="rules.title"
                      rows="2"
                      row-height="15"
                      maxlength="100"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" md="6" sm="12" xs="12" lg="6" xl="6">
                    <v-textarea
                      v-model="getaddresslistbusins.addressline2"
                      label="Address Line 2 *"
                      outlined
                      :rules="rules.title"
                      auto-grow
                      maxlength="100"
                      rows="1"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row class="mt-n6" v-if="getaddresslist.is_bus_adrs == false">
                  <v-col cols="12" md="3" sm="12" xs="12" lg="3" xl="3">
                    <v-text-field
                      v-model="getaddresslistbusins.city"
                      label="City *"
                      color="primary"
                      maxlength="20"
                      required
                      outlined
                      dense
                      :rules="rules.title"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" xs="12" lg="3" xl="3">
                    <v-select
                      v-model="getaddresslistbusins.state"
                      label="Select State *"
                      color="primary"
                      :items="stateList"
                      item-text="state_name"
                      required
                      outlined
                      dense
                      :rules="rules.title"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" xs="12" lg="3" xl="3">
                    <v-text-field
                      v-model="getaddresslistbusins.country"
                      readonly
                      label="Country"
                      color="primary"
                      required
                      outlined
                      dense
                      :rules="rules.title"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" xs="12" lg="3" xl="3">
                    <v-text-field
                      v-model="getaddresslistbusins.zip_code"
                      label="Enter Postal Code *"
                      @keypress="isNumber($event)"
                      maxlength="5"
                      color="primary"
                      required
                      outlined
                      dense
                      :rules="[
                        (v) => !!v || 'Required',
                        (v) =>
                          /^(?=[a-zA-Z0-9]{0,16}$)[0-9 +-]{0,16}$/.test(v) ||
                          'Invalid Input',
                        (v) => v.length >= 3 || 'Mini 3 characters',
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-n3">
                  <v-spacer />
                  <v-btn @click="e1--" text>back</v-btn>
                  <v-btn color="primary" @click="stepper2()" class="mr-4"
                    >Continue</v-btn
                  >
                </v-row>
                <v-card-actions></v-card-actions>
              </v-card>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card height="fit-content" flat>
              <v-row>
                <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                  <v-data-table
                    :headers="headersUploader"
                    :items="fileList"
                    hide-default-footer
                    loading-text="Uploading.."
                    dense
                  >
                    <template v-slot:top>
                      <v-form ref="uploadForm">
                        <v-layout row wrap>
                          <v-col
                            cols="12"
                            md="5"
                            sm="12"
                            xs="12"
                            lg="5"
                            xl="5"
                            class="mt-n2"
                          >
                            <label class="caption">Documents</label>
                            <v-select
                              v-model="documentsupload"
                              :items="documentsList"
                              dense
                              solo
                              shaped
                              label="Select Document"
                              return-object
                            ></v-select>
                            <!-- @change="documentChange()" -->
                          </v-col>
                          <v-col
                            cols="12"
                            md="3"
                            sm="12"
                            xs="12"
                            lg="3"
                            xl="3"
                            class="mt-n2"
                            v-if="documentsupload == 'Other Documents'"
                          >
                            <label class="caption">Document Name</label>
                            <v-text-field
                              v-model="documentsuploadname"
                              dense
                              solo
                              shaped
                              label="Document name"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            md="3"
                            sm="12"
                            xs="12"
                            lg="3"
                            xl="3"
                            class="mt-n2"
                          >
                            <label class="caption">Upload Document</label>
                            <v-file-input
                              v-model="file"
                              dense
                              :disabled="!documentsupload"
                              show-size
                              counter
                              solo
                              label="Upload"
                              @change="beforeaddingfile()"
                            ></v-file-input>
                            <template v-slot:selection="{ file }">
                              <v-chip small label color="primary">
                                {{ file }}
                              </v-chip>
                            </template>
                          </v-col>
                          <!-- <v-col lg="3"> </v-col>
                            <v-col
                              justify="end"
                              v-if="file != null && documentsupload != ''"
                              lg="2"
                            >
                              <v-btn
                                rounded
                                color="primary"
                                class="mt-5"
                                :loading="loadingAdd"
                              >
                                <v-icon left dark>mdi-plus</v-icon>Add
                              </v-btn>
                            </v-col> -->
                        </v-layout>
                      </v-form>
                    </template>
                    <template v-slot:[`item.doc_url`]="{ item }">
                      <v-avatar tile size="36" class="mt-1">
                        <img
                          v-if="
                            item.docExtn == 'jpeg' ||
                            item.docExtn == 'JPEG' ||
                            item.docExtn == 'jpg' ||
                            item.docExtn == 'JPG' ||
                            item.docExtn == 'png' ||
                            item.docExtn == 'PNG' ||
                            item.docExtn == 'webp' ||
                            item.docExtn == 'WEBP'
                          "
                          :src="item.doc_url"
                          alt="error"
                          @click="openImageInNewTab(item.doc_url)"
                        />

                        <v-icon
                          @click="openImageInNewTab(item.doc_url)"
                          v-else-if="
                            item.docExtn == 'txt' || item.docExtn == 'TXT'
                          "
                          left
                          color="blue"
                          >mdi-file-document</v-icon
                        >
                        <v-icon
                          @click="openImageInNewTab(item.doc_url)"
                          v-else-if="
                            item.docExtn == 'pdf' || item.docExtn == 'PDF'
                          "
                          left
                          color="red"
                          >mdi-file-pdf</v-icon
                        >
                        <v-icon
                          @click="openImageInNewTab(item.doc_url)"
                          v-else-if="
                            item.docExtn == 'xls' ||
                            item.docExtn == 'XLS' ||
                            item.docExtn == 'xlsx' ||
                            item.docExtn == 'XLSX'
                          "
                          left
                          color="green"
                          >mdi-file-excel</v-icon
                        >
                        <v-icon
                          @click="openImageInNewTab(item.doc_url)"
                          v-else-if="
                            item.docExtn == 'doc' ||
                            item.docExtn == 'DOC' ||
                            item.docExtn == 'docx' ||
                            item.docExtn == 'DOCX'
                          "
                          left
                          color="blue"
                          >mdi-file-word</v-icon
                        >
                        <v-icon
                          @click="openImageInNewTab(item.doc_url)"
                          v-else
                          left
                          color="blue"
                          >mdi-file-document</v-icon
                        >
                      </v-avatar>
                      <div>
                        <span class="caption">{{ item.fileName }}</span>
                      </div>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon small color="red" @click="confirmdeleteItem(item)"
                        >mdi-delete</v-icon
                      >
                    </template>
                    <template v-slot:[`item.Status`]="{}">
                      <v-icon color="green" medium>mdi-check-bold</v-icon>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-dialog v-model="confirmDeleteDialog" width="400" persistent>
                <v-card class="overflow-hidden">
                  <v-toolbar class="elevation-0" dense>
                    <span> Are you sure you want to submit?</span>
                    <v-spacer></v-spacer>
                    <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
                  </v-toolbar>
                  <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-row class="mt-2" style="margin-left: 200px">
                      <v-btn
                        text
                        width="90px"
                        class="mb-4 red--text"
                        @click="confirmDeleteDialog = false"
                        >Back</v-btn
                      >
                      <v-btn
                        text
                        width="90px"
                        class="mb-4 primary--text"
                        @click="deleteItemFile()"
                        >Submit</v-btn
                      >
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card>
            <v-row class="mt-5">
              <v-spacer />
              <v-btn @click="e1--" text>back</v-btn>
              <v-btn color="primary" @click="stepper3()" class="mr-4"
                >Continue
              </v-btn>
            </v-row>
            <v-card-actions></v-card-actions>
          </v-stepper-content>
          <v-stepper-content step="4">
            <v-card class="elevation-0">
              <v-form ref="cardInfon">
                <v-row class="mt-2">
                  <v-col cols="12" md="4" sm="12" xs="12" lg="4" xl="4">
                    <v-text-field
                      v-model="infoCard.fname"
                      label="First Name *"
                      color="primary"
                      :rules="rules.title"
                      maxlength="25"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" sm="12" xs="12" lg="4" xl="4">
                    <v-text-field
                      v-model="infoCard.mname"
                      label="Middle Name"
                      color="primary"
                      required
                      outlined
                      maxlength="25"
                      max
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" sm="12" xs="12" lg="4" xl="4">
                    <v-text-field
                      v-model="infoCard.lname"
                      label="Last Name *"
                      color="primary"
                      :rules="rules.title"
                      maxlength="25"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col
                    class="mt-n6"
                    cols="12"
                    md="4"
                    sm="12"
                    xs="12"
                    lg="4"
                    xl="4"
                  >
                    <v-text-field
                      outlined
                      dense
                      append-icon="mdi-person"
                      :rules="emailRules"
                      label="E-mail *"
                      value
                      v-model="infoCard.email_id"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    class="mt-n6"
                    cols="12"
                    md="4"
                    sm="12"
                    xs="12"
                    lg="4"
                    xl="4"
                  >
                    <v-text-field
                      dense
                      label="Designation *"
                      v-model="infoCard.designation"
                      maxlength="30"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col
                    class="mt-n6"
                    cols="12"
                    md="4"
                    sm="12"
                    xs="12"
                    lg="4"
                    xl="4"
                  >
                    <v-text-field
                      dense
                      label="Passport/NRIC No *"
                      :rules="[
                        (v) => !!v || 'Required',
                        (v) =>
                          /^(?=[a-zA-Z0-9]{0,30}$)[0-9a-zA-Z]{0,64}$/.test(v) ||
                          'Invalid Input',
                        (v) =>
                          (v && v.length < 19) || 'Invalid Passport/NRIC No.',
                      ]"
                      maxlength="18"
                      v-model="infoCard.idnum"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col
                    class="mt-n5"
                    cols="12"
                    md="2"
                    sm="12"
                    xs="12"
                    lg="2"
                    xl="2"
                  >
                    <v-text-field
                      dense
                      v-model="infoCard.ccode"
                      label="Country Code"
                      maxlength="12"
                      readonly
                      outlined
                      disabled
                      prefix="+"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    class="mt-n5"
                    cols="12"
                    md="3"
                    sm="12"
                    xs="12"
                    lg="3"
                    xl="3"
                  >
                    <v-text-field
                      dense
                      placeholder="Mobile Number *"
                      :rules="[
                        (v) => !!v || 'Required',
                        (v) =>
                          /^(?=[a-zA-Z0-9@._%+-]{0,30}$)[0-9 +-]{0,64}$/.test(
                            v
                          ) || 'Invalid',
                        (v) => (v && v.length < 11) || 'Invalid Contact Number',
                        (v) => (v && v.length > 8) || 'Invalid Contact Number',
                      ]"
                      @input="validateInput1"
                      maxlength="10"
                      :color="redcolor2"
                      :error="error2"
                      :hint="invalidcontact2"
                      label="Mobile Number"
                      prefix="+60"
                      v-model="infoCard.mobileno"
                      @keypress="isNumber($event)"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col class="mt-n6" cols="1">
                        <v-text-field
                          dense
                          label="Cc*"
                          v-model="countryCode"
                          maxlength="12"
                          readonly
                          @keypress="isNumber(event)"
                          outlined
                        ></v-text-field
                      ></v-col> -->
                </v-row>
              </v-form>
              <v-row class="mt-n2">
                <v-spacer />
                <v-btn @click="e1--" text>back</v-btn>
                <v-btn color="primary" @click="stepper4()" class="mr-4"
                  >Continue</v-btn
                >
              </v-row>

              <v-card-actions></v-card-actions>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="5">
            <v-card class="mb-12 elevation-0" height="fit-content">
              <v-row class="mr-16" justify="end">
                <v-col cols="12" sm="12" xs="12" md="1" lg="1">
                  <v-card-actions>
                    <v-btn class="primary" @click="create_user = true" dense>
                      <v-icon small class="mr-1">mdi-plus</v-icon>Add
                      Bank</v-btn
                    >
                  </v-card-actions>
                </v-col>
              </v-row>
              <v-row class="mt-4">
                <v-col cols="12" sm="12" xs="12" md="12" lg="12">
                  <v-data-table
                    dense
                    :headers="headers"
                    :items="BankDetails"
                    hide-default-footer
                  >
                    <template v-slot:[`item.sl_no`]="{ item }">
                      <span class="caption">
                        {{ BankDetails.indexOf(item) + 1 }}
                      </span>
                    </template>
                    <template v-slot:[`item.primary_acc`]="{ item }">
                      <v-checkbox
                        disabled
                        v-model="item.primary_acc"
                      ></v-checkbox>
                    </template>

                    <template v-slot:[`item.Actions`]="{ item }">
                      <v-icon
                        small
                        color="green"
                        class="mr-2"
                        row
                        @click="Open(item)"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        small
                        color="red"
                        class="mr-2"
                        row
                        @click="delet(item)"
                        >mdi-delete</v-icon
                      >
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>

            <v-row class="mt-n3">
              <v-spacer />
              <v-btn @click="e1--" text>back</v-btn>
              <v-btn color="primary" @click="stepper5()" class="mr-4"
                >Continue
              </v-btn>
            </v-row>
            <v-card-actions></v-card-actions>
            <v-dialog v-model="edit_dialog" width="700" persistent>
              <v-card>
                <v-toolbar flat color="transparent" dark dense>
                  <v-toolbar-title
                    ><span class="black--text"
                      >Edit Bank Info</span
                    ></v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-icon small @click="cancel()" color="black">md-close</v-icon>
                <v-card-text class="mt-2 black--text subtitle-1">
                  <v-form ref="editbank">
                    <v-row justify="center" align="center">
                      <v-col cols="12" sm="12" xs="12" md="5" lg="5">
                        <v-select
                          dense
                          label="Account Type *"
                          outlined
                          :items="AccTypes"
                          v-model="account_type"
                          :rules="Rules"
                        >
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="12" xs="12" md="5" lg="5">
                        <v-select
                          dense
                          label="Bank Name *"
                          outlined
                          :items="BankNames"
                          v-model="bank_name"
                          :rules="Rules"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col cols="12" sm="12" xs="12" md="5" lg="5">
                        <v-text-field
                          dense
                          label="Account Name *"
                          outlined
                          v-model="account_name"
                          :rules="rule"
                          maxlength="40"
                        >
                        </v-text-field
                      ></v-col>
                      <v-col cols="12" sm="12" xs="12" md="5" lg="5">
                        <v-text-field
                          dense
                          label="Bank Account Number *"
                          outlined
                          v-model="bank_account_num"
                          :rules="[
                            (v) => !!v || 'Required',
                            (v) =>
                              /^(?=[a-zA-Z0-9]{0,16}$)[0-9 +-]{0,16}$/.test(
                                v
                              ) || 'Invalid Input',
                            (v) => v.length >= 8 || 'Mini 8 characters',
                            (v) => v.length <= 16 || 'Max 16 characters',
                          ]"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-checkbox
                      v-model="Primary"
                      label="Primary Account"
                      class="mt-n2 ml-13"
                    ></v-checkbox>
                  </v-form>
                  <v-row justify="end">
                    <v-card-actions>
                      <v-btn
                        dark
                        @click="edit_dialog = false"
                        color="primary"
                        text
                      >
                        BACK
                      </v-btn>
                      <v-btn color="primary" @click="edit()" text>SAVE</v-btn>
                    </v-card-actions>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog v-model="create_user" width="700" persistent>
              <v-card>
                <v-card-title><span>Add Bank</span> </v-card-title>
                <v-card-text class="mt-2 black--text subtitle-1">
                  <v-form ref="Addbankinfonew">
                    <v-row justify="center" align="center">
                      <v-col cols="12" sm="12" xs="12" md="5" lg="5">
                        <v-select
                          v-model="AccType"
                          label="Account Type *"
                          color="primary"
                          required
                          :items="AccTypes"
                          outlined
                          dense
                          :rules="Rules"
                        >
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="12" xs="12" md="5" lg="5">
                        <v-select
                          v-model="BankName"
                          label="Bank Name *"
                          color="primary"
                          required
                          :items="BankNames"
                          outlined
                          dense
                          :rules="Rules"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col cols="12" sm="12" xs="12" md="5" lg="5">
                        <v-text-field
                          v-model="AccName"
                          color="primary"
                          label="Account Name *"
                          required
                          outlined
                          dense
                          :rules="rule"
                          maxlength="40"
                        >
                        </v-text-field
                      ></v-col>
                      <v-col cols="12" sm="12" xs="12" md="5" lg="5">
                        <v-text-field
                          v-model="AccNo"
                          label="Bank Account Number *"
                          required
                          maxlength="16"
                          :hint="accountcheck"
                          :color="redcolor"
                          outlined
                          dense
                          :rules="[
                            (v) => !!v || 'Required',
                            (v) =>
                              /^(?=[a-zA-Z0-9]{0,16}$)[0-9 +-]{0,16}$/.test(
                                v
                              ) || 'Invalid Input',
                            (v) => v.length >= 8 || 'Mini 8 characters',
                            (v) => v.length <= 16 || 'Max 16 characters',
                          ]"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-checkbox
                      v-model="primary2"
                      label="Primary Account"
                      class="mt-n2 ml-13"
                    ></v-checkbox>
                    <v-row justify="end">
                      <v-card-actions>
                        <v-btn color="primary" text @click="create_user = false"
                          >CANCEL</v-btn
                        >
                        <v-btn
                          color="primary"
                          @click="Addbankinfo()"
                          text
                          :disabled="error == true"
                          >ADD</v-btn
                        >
                      </v-card-actions>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="400px">
              <v-card>
                <v-card-title class="text-subtitle-1"
                  >Are you sure you want to delete this item?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="primary" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-stepper-content>
          <v-stepper-content step="6">
            <!-- <Preview
                  v-if="e1 == 6"
                  :getbasicinfo="getbasicinfo"
                  :getaddresslist="getaddresslist"
                  :getaddresslistbusins="getaddresslistbusins"
                  :infoCard="infoCard"
                  :filelistOrg="filelistOrg"
                  v-on:backChild="stepper6"
                  :BankDetails="BankDetails"
                /> -->
            <v-card height="fit-content" flat>
              <v-form ref="formStep" lazy-validation>
                <v-row
                  style="backdrop-filter: blur(10px)"
                  class="elevation-6 ma-2 mt-4"
                >
                  <v-col cols="12" md="5" sm="5">
                    <v-card-title class="primary--text ml-n3 mt-n5"
                      >Key Person Details</v-card-title
                    >
                    <v-row class="mb-n9">
                      <v-col cols="12" md="12" sm="6">
                        <v-text-field
                          v-model="getbasicinfo.first_name"
                          label="First Name"
                          color="primary"
                          required
                          readonly
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                      <v-col cols="12" md="12" sm="6">
                        <v-text-field
                          v-model="getbasicinfo.middle_name"
                          label="Middle Name"
                          color="primary"
                          readonly
                          required
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                      <v-col cols="12" md="12" sm="6">
                        <v-text-field
                          label="Last Name"
                          v-model="getbasicinfo.last_name"
                          color="primary"
                          required
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                      <v-col cols="6" md="6" sm="6">
                        <v-text-field
                          label="Designation"
                          color="primary"
                          readonly
                          v-model="getbasicinfo.designation"
                          required
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" md="6" sm="6">
                        <v-text-field
                          label="Contact Number"
                          v-model="getbasicinfo.contact_num"
                          maxlength="11"
                          prefix="+60"
                          color="primary"
                          readonly
                          required
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                      <v-col cols="12" md="12" sm="6">
                        <v-text-field
                          outlined
                          dense
                          readonly
                          append-icon="mdi-person"
                          label="E-mail"
                          v-model="getbasicinfo.email_id"
                          value
                        ></v-text-field
                      ></v-col>
                    </v-row>
                    <!-- <v-row class="mb-n9">
                <v-col cols="4" md="4" sm="4">
                  <v-text-field
                    readonly
                    label="Country Code"
                    v-model="cCode"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="8" md="8" sm="8">
                  <v-text-field
                    label="Contact Number"
                    v-model="getbasicinfo.contact_num"
                    maxlength="12"
                    prefix="+60"
                    color="primary"
                    readonly
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row> -->
                  </v-col>
                  <v-divider light vertical class="mx-n1"></v-divider>
                  <v-col cols="12" md="7" sm="7">
                    <v-row>
                      <v-card-title class="primary--text mt-n2"
                        >Company Details</v-card-title
                      >
                    </v-row>
                    <v-row class="mb-n8">
                      <v-col cols="12" md="12" sm="6">
                        <v-textarea
                          class="mt-n3"
                          label="Company Name"
                          v-model="getbasicinfo.comp_name"
                          maxlength="12"
                          color="primary"
                          required
                          dense
                          readonly
                          outlined
                          auto-grow
                          rows="2"
                          row-height="35"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row class="mb-n7">
                      <v-col cols="6" md="6" sm="6">
                        <v-text-field
                          class="mt-n0"
                          v-model="getbasicinfo.ent_type"
                          readonly
                          label="Type of Entity"
                          required
                          outlined
                          dense="dense"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" md="6" sm="6">
                        <v-text-field
                          class="mt-n0"
                          v-model="getbasicinfo.registration_num"
                          label="Company Registration Number"
                          color="primary"
                          maxlength="15"
                          required
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="mb-n7">
                      <v-col cols="8">
                        <v-text-field
                          label="Nature of business"
                          v-model="getbasicinfo.nat_of_busn"
                          readonly
                          required
                          outlined
                          dense="dense"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="elevation-6 ma-2 mt-4">
                  <!-- <v-divider light vertical class="mx-n1"></v-divider> -->
                  <v-col cols="12">
                    <v-card-title class="primary--text ml-n3 mt-n5"
                      >Registered Address</v-card-title
                    >
                  </v-col>

                  <v-col class="mt-n5" cols="12" md="6" sm="6">
                    <v-textarea
                      v-model="getaddresslist.addressline1"
                      label="Address Line 1"
                      outlined
                      readonly
                      auto-grow
                      rows="2"
                      row-height="15"
                    ></v-textarea>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="6" sm="6">
                    <v-textarea
                      label="Address Line 2"
                      v-model="getaddresslist.addressline2"
                      outlined
                      auto-grow
                      readonly
                      rows="2"
                      row-height="15"
                    ></v-textarea>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="3" sm="3">
                    <v-text-field
                      label="City"
                      v-model="getaddresslist.city"
                      color="primary"
                      readonly
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="3" sm="3">
                    <v-text-field
                      label="Selected State"
                      color="primary"
                      required
                      readonly
                      v-model="getaddresslist.state"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="3" sm="3">
                    <v-text-field
                      label="Country"
                      v-model="getaddresslist.country"
                      readonly
                      color="primary"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="3" sm="3">
                    <v-text-field
                      label="Enter Postal Code"
                      maxlength="5"
                      readonly
                      v-model="getaddresslist.zip_code"
                      color="primary"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-card-title class="primary--text ml-n3 mt-n10"
                      >Business Address</v-card-title
                    ></v-col
                  >
                  <v-col cols="4">
                    <v-checkbox
                      class="mt-n6"
                      dense
                      readonly
                      v-model="getaddresslist.is_bus_adrs"
                      label="Same As Registered Address?"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row v-if="getaddresslist.is_bus_adrs == false" class="pa-3">
                  <v-col class="mt-n5" cols="12" md="6" sm="6">
                    <v-textarea
                      label="Address Line 1"
                      v-model="getaddresslistbusins.addressline1"
                      outlined
                      auto-grow
                      readonly
                      rows="2"
                      row-height="15"
                    ></v-textarea>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="6" sm="6">
                    <v-textarea
                      v-model="getaddresslistbusins.addressline2"
                      label="Address Line 2."
                      outlined
                      readonly
                      auto-grow
                      rows="1"
                    ></v-textarea>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="3" sm="3">
                    <v-text-field
                      label="City"
                      v-model="getaddresslistbusins.city"
                      color="primary"
                      required
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="3" sm="3">
                    <v-text-field
                      label="Selected State"
                      color="primary"
                      readonly
                      item-text="state_name"
                      v-model="getaddresslistbusins.state"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="3" sm="3">
                    <v-text-field
                      readonly
                      label="Country"
                      color="primary"
                      v-model="getaddresslistbusins.country"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="3" sm="3">
                    <v-text-field
                      label="Enter Postal Code"
                      v-model="getaddresslistbusins.zip_code"
                      maxlength="5"
                      readonly
                      color="primary"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- <v-row class="mt-n8 pa-0">
            <v-card-title class="text">Business Address</v-card-title>
            <v-col>
              <v-checkbox
                class="mt-4"
                dense
                v-model="checkbox"
                @click="calladdress"
                label="Same As Registered Address?"
              ></v-checkbox>
            </v-col>
          </v-row> -->

                <v-row class="elevation-6 ma-2 mt-4">
                  <!-- <v-card> -->
                  <v-col cols="12">
                    <v-card-title class="primary--text ml-n3 mt-n5"
                      >First Card Information</v-card-title
                    >
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="4" sm="3">
                    <v-text-field
                      label="First Name"
                      v-model="infoCard.fname"
                      color="primary"
                      required
                      outlined
                      readonly
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="4" sm="3">
                    <v-text-field
                      v-model="infoCard.mname"
                      label="Middle Name"
                      color="primary"
                      required
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="12" md="4" sm="3">
                    <v-text-field
                      v-model="infoCard.lname"
                      label="Last Name"
                      color="primary"
                      required
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="6">
                    <v-text-field
                      outlined
                      readonly
                      dense
                      v-model="infoCard.email_id"
                      append-icon="mdi-person"
                      label="E-mail"
                      value
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="2">
                    <v-text-field
                      dense
                      v-model="infoCard.ccode"
                      label="Country Code*"
                      maxlength="12"
                      readonly
                      outlined
                      disabled
                      prefix="+"
                    ></v-text-field>
                  </v-col>
                  <v-col class="mt-n5" cols="4">
                    <v-text-field
                      dense
                      v-model="infoCard.mobileno"
                      label="Mobile Number"
                      maxlength="12"
                      readonly
                      @keypress="isNumber(event)"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" class="mt-n4">
                    <v-text-field
                      dense
                      readonly
                      v-model="infoCard.designation"
                      label="Designation"
                      maxlength="25"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="mt-n4">
                    <v-text-field
                      dense
                      label="Passport/NRIC No."
                      v-model="infoCard.idnum"
                      maxlength="18"
                      readonly
                      outlined
                    ></v-text-field>
                  </v-col>
                  <!-- </v-card> -->
                </v-row>
                <v-row class="elevation-6 ma-2 mt-4">
                  <v-col class="mt-n5" cols="12">
                    <v-card-title class="primary--text ml-n3 mt-n0"
                      >Bank Information</v-card-title
                    >
                  </v-col>
                  <v-col class="mt-n5" cols="12">
                    <v-data-table
                      dense
                      :headers="headers1"
                      :items="BankDetails"
                      hide-default-footer
                    >
                      <template v-slot:[`item.sl_no`]="{ item }">
                        <span class="caption">
                          {{ BankDetails.indexOf(item) + 1 }}
                        </span>
                      </template>
                      <template v-slot:[`item.primary_acc`]="{ item }">
                        <v-checkbox
                          v-model="item.primary_acc"
                          readonly
                        ></v-checkbox>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-row class="elevation-6 ma-2 mt-4">
                  <v-col class="mt-n2" cols="12">
                    <v-card-title class="primary--text ml-n3 mt-n2"
                      >Uploaded Documents</v-card-title
                    >
                  </v-col>
                  <v-col class="mt-n5">
                    <v-data-table
                      :headers="headersUploader2"
                      :items="fileList"
                      hide-default-footer
                      class="elevation-0"
                    >
                      <template v-slot:[`item.doc_url`]="{ item }">
                        <v-avatar tile size="36" class="mt-1">
                          <img
                            v-if="
                              item.docExtn == 'jpeg' ||
                              item.docExtn == 'JPEG' ||
                              item.docExtn == 'jpg' ||
                              item.docExtn == 'JPG' ||
                              item.docExtn == 'png' ||
                              item.docExtn == 'PNG' ||
                              item.docExtn == 'webp' ||
                              item.docExtn == 'WEBP'
                            "
                            :src="item.doc_url"
                            alt="error"
                            @click="openImageInNewTab(item.doc_url)"
                          />

                          <v-icon
                            @click="openImageInNewTab(item.doc_url)"
                            v-else-if="item.docExtn == 'pdf'"
                            left
                            color="red"
                            >mdi-file-pdf</v-icon
                          >
                          <v-icon
                            @click="openImageInNewTab(item.doc_url)"
                            v-else-if="
                              item.docExtn == 'xls' || item.docExtn == 'xlsx'
                            "
                            left
                            color="green"
                            >mdi-file-excel</v-icon
                          >
                          <v-icon
                            @click="openImageInNewTab(item.doc_url)"
                            v-else-if="
                              item.docExtn == 'doc' || item.docExtn == 'docx'
                            "
                            left
                            color="blue"
                            >mdi-file-word</v-icon
                          >
                          <v-icon
                            @click="openImageInNewTab(item.doc_url)"
                            v-else
                            left
                            color="blue"
                            >mdi-file-document</v-icon
                          >
                        </v-avatar>
                        <div>
                          <span class="caption">{{ item.fileName }}</span>
                        </div>
                      </template>
                      <!-- <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                              small
                              color="red"
                              @click="confirmdeleteItem(item)"
                              >mdi-delete</v-icon
                            >
                          </template> -->
                    </v-data-table></v-col
                  >
                </v-row>
                <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  xl="12"
                  lg="12"
                  xs="12"
                  class="mt-n2"
                >
                  <v-checkbox v-model="checkboxTrns">
                    <template v-slot:label>
                      <div class="caption">
                        By clicking submit or otherwise continuing to use this
                        service, you agree you have read, understand and accept
                        Glyd's
                        <a
                          target="_blank"
                          href="https://glyd.com.my/term-and-condition.html"
                          @click.stop
                        >
                          <span class="caption red--text"
                            >Terms of Service</span
                          >
                        </a>
                        and
                        <a
                          target="_blank"
                          href="https://glyd.com.my/privacy-policy.html"
                          @click.stop
                        >
                          <span class="caption red--text">Privacy Policy</span>
                        </a>
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-form>
              <v-row class="mt-8">
                <v-spacer />

                <v-btn class="mr-4 mt-n2" @click="e1--" text>back</v-btn>
                <v-btn
                  class="mr-5 mt-n2"
                  color="primary"
                  @click="ConfirmSubmit()"
                  >Submit</v-btn
                >
                <!-- <v-btn  text> back </v-btn> -->
              </v-row>
              <v-card-actions></v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>

    <v-dialog v-model="dialogNew1" persistent max-width="400px">
      <v-card class="overflow-hidden">
        <v-toolbar class="elevation-0" dense>
          <span> Are you sure you want to submit ? </span>
          <v-spacer></v-spacer>
          <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
        </v-toolbar>
        <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-row class="mt-2" style="margin-left: 200px">
            <v-btn text width="90px" class="mb-4 red--text" @click="dialogclose"
              >Back</v-btn
            >
            <v-btn
              text
              width="90px"
              class="mb-4 primary--text"
              @click="finalSubmit()"
              >Submit</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  data: () => ({
    checkboxTrns: false,
    dialogNew1: false,
    checkaccessdata: {},
    sure_dialog: false,
    confirmDeleteDialog: false,
    getaddresslist: {
      is_bus_adrs: false,
      addressline1: "",
      addressline2: "",
      city: "",
      state: "",
      zip_code: "",
      country: "Malaysia",
    },
    getaddresslistbusins: {
      addressline1: "",
      addressline2: "",
      city: "",
      state: "",
      zip_code: "",
      country: "Malaysia",
    },
    fileList: [],
    filelistOrg: [],
    AccTypes: ["Savings", "Current"],
    AccType: "",
    BankName: "",
    AccNo: "",
    file: [],
    BankDetails: [],
    headersUploader: [
      {
        text: "Documents",
        align: "start",
        sortable: false,
        value: "doc_name",
      },
      {
        text: "File",
        align: "start",
        sortable: false,
        value: "doc_url",
      },
      {
        text: "Action",
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    headersUploader2: [
      {
        text: "Documents",
        align: "start",
        sortable: false,
        value: "doc_name",
      },
      {
        text: "File",
        align: "start",
        sortable: false,
        value: "doc_url",
      },
      // {
      //   text: "Action",
      //   align: "start",
      //   sortable: false,
      //   value: "actions",
      // },
    ],
    stateList: [],
    documentsupload: "",
    documentsuploadname: "",
    dialogDelete: false,

    documentsList: [
      {
        name: "Photocopy of IC / Passport (Front & Back) of Director(s) / Partner(s) / Owner(s)",
        code: "PhotoIc",
      },
      {
        name: "SSM Company Profile Summary Document",
        code: "ssmProf",
      },

      {
        name: "Certificate of Registration (Form 3 - Association)",
        code: "certif",
      },
      {
        name: "Copy of Rules & Regulation or Constitution",
        code: "copyRules",
      },
      {
        name: "Payroll Agreement",
        code: "payAgmt",
      },

      {
        name: "KYC documents of Partners/Directors",
        code: "kycDoc",
      },
      {
        name: "CTOS Report",
        code: "CTOS",
      },
      {
        name: "Others",
        code: "others",
      },
    ],
    typeofentities: [
      "Company",
      "Partnership",
      "Sole Proprietorship",
      "Society",
      "Club",
      "Association",
    ],
    natureofbusinesses: [
      "Construction",
      "Manufacturing",
      "Hotel and Restaurant",
      "Retail trade",
      "Agriculture",
      "Arts and entertainment",
      "Education",
      "Finance and insurance",
      "Health care",
      "Transportation and warehousing",
      "Utilities",
      "Wholesale trade",
      "Information and cultural industries",
      "Management of companies and enterprises",
      "Mining, oil and gas",
      "Scientific and technical services",
      "Public administration",
      "Real estate",
      "Waste Management",
      "Others",
    ],
    rules: {
      //step 1 rules
      title: [(v) => !!v || "Required"],
      name: [],
    },
    rule: [(v) => !!v || "required!"],
    bankinfocheck: false,

    emailRules: [
      (v) => !!v || "E-Mail is required!",
      (v) => /.+@.+\..+/.test(v) || "Enter appropriate E-Mail",
    ],

    rules1: {
      required: [(v) => !!v || "Required"],
      counter: [(v) => v.length <= 20 || "Max 20 characters"],

      length: [(v) => v.length <= 100 || "Max 100 characters"],
    },
    namerules: [
      (v) => !!v || "Required",
      (v) => (v && v.length >= 5) || "Minimum 5 characters",
      (v) => v.length <= 60 || "Name must be less than 60 characters",
    ],
    overlay: false,
    getbasicinfo: {
      comp_name: "",
      ent_type: "",
      nat_of_busn: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      designation: "",
      contact_num: "",
      ccode: "60",
      registration_num: "",
      email_id: "",
      user_id: 0,
      corp_id: 0,
    },
    // is_bus_adrs: false,
    infoCard: {
      userid: 0,
      designation: "",
      mobil_no: "",
      idnum: "",
      email_id: "",
      last_name: "",
      middle_name: "",
      first_name: "",
      ccode: "60",
    },
    addBankDialog: false,
    AddBank: "",
    AccName: "",
    headersStep5: [
      {
        text: "Account Type",
        align: "start",
        value: "AccType",
      },
      { text: "Account Name", value: "AccName" },
      { text: "Bank Name", value: "BankName" },
      { text: "Bank Account Number", value: "BankAccNu" },
      { text: "Select", value: "selectradio" },
    ],
    desserts: [],
    e1: 1,
    Primary: false,
    primary2: false,
    editObject: {},

    create_user: false,
    firstName: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    designation: "",
    redcolor: "",
    error: false,
    contact_num: "",
    email_id: "",
    create_user_dialog: false,
    primary_acc: false,
    rootUser: false,

    bank_account_num: "",
    account_name: "",
    bank_name: "",
    account_type: "",
    SnackBarComponent: {},
    department: "",
    editedIndex: 0,
    deptid: [],
    edit_dialog: false,
    bankaccnum: "",
    banknme: "",
    headers: [
      { text: "SL NO", value: "sl_no", sortable: false },
      { text: "ACCOUNT TYPE", value: "account_type", sortable: false },
      { text: "ACCOUNT NAME", value: "account_name", sortable: false },
      { text: "BANK NAME", value: "bank_name", sortable: false },
      { text: "ACCOUNT NO", value: "bank_account_num", sortable: false },
      { text: "Primary Account", value: "primary_acc", sortable: false },
      { text: "ACTIONS", value: "Actions", sortable: false },
    ],
    headers1: [
      { text: "SL NO", value: "sl_no", sortable: false },
      { text: "ACCOUNT TYPE", value: "account_type", sortable: false },
      { text: "ACCOUNT NAME", value: "account_name", sortable: false },
      { text: "BANK NAME", value: "bank_name", sortable: false },
      { text: "ACCOUNT NO", value: "bank_account_num", sortable: false },
      { text: "Primary Account", value: "primary_acc", sortable: false },
    ],

    BankNames: [
      "Affin Bank Berhad",
      "Alliance Bank Malaysia Berhad",
      "Al Rajhi Banking and Investment Corporation (M) Berhad",
      "Ambank/Amfinance",
      "Bangkok Bank Berhad",
      "Bank Islam Malaysia Berhad",
      "Bank Kerjasama rakyat Malaysia Berhad",
      "Bank Muamalat Malaysia Berhad",
      "Bank of America",
      "Bank of China (Malaysia) Berhad",
      "Bank Pertanian Malaysia Berhad (AGROBANK)",
      "Bank Simpanan Nasional Berhad",
      "BNP Paribas Malaysia Berhad",
      "China Construction Bank (M) Berhad",
      "CIMB Bank Berhad",
      "Citibank Berhad",
      "Deutsche Bank (M) Berhad",
      "Hong Leong Bank",
      "HSBC Bank Malaysia Berhad",
      "Industrial and Commercial Bank of China (M) Berhad",
      "J.P. Morgan Chase Bank Bhd",
      "Kuwait Finance House (M) Berhad",
      "Maybank",
      "MBSB Bank Berhad",
      "Mizuho Corporate Bank Malaysia Berhad",
      "MUFG Bank (M) Berhad",
      "OCBC Bank (M) Berhad",
      "Public Bank Berhad/Public Islamic Bank Berhad",
      "RHB Bank",
      "Standard Chartered Bank Malaysia Berhad",
      "Sumitomo Mitsui Banking Corporation Malaysia Berhad",
      "United Overseas Bank Berhad",
    ],
    // accntRules: [
    //   (v) => !!v || "Account Number is required!",

    //   (v) => /^[1-9]\d*(\.\d+)?$/.test(v) || "Enter only numbers",
    //   (v) => /^(?!0{9})/.test(v) || "Number cannot be all zeros",

    //   (v) => (v && v.length >= 16) || "Invalid Account Number",
    // ],
    // rule: [(v) => !!v || "required!"],
    Rules: [(v) => !!v || "please fill this field"],
    BasicDetails: {},
    primeaccc: "",
    filename: "",
    accountcheck: "",
    isInvalidInput: false,

    error1: false,
    redcolor1: "",
    invalidcontact: "",
    error2: false,
    redcolor2: "",
    invalidcontact2: "",
  }),

  // watch: {
  //   is_bus_adrs(val) {
  //     console.log("val", val);
  //     if (val == true ? 1 : 0) {
  //       this.getaddresslist.checkbox = val;
  //     }
  //   },
  // },
  watch: {
    AccNo(val) {
      if (val == this.bankaccnum && this.BankName == this.banknme) {
        this.$store.commit("snackbar/showMessage", {
          content: "Account Number Already Exists",
          color: "red",
        });
        this.accountcheck = "Account Number Already Exists";
        this.redcolor = "red";
        this.error = true;
      } else {
        this.accountcheck = "";
        this.redcolor = "";
        this.error = false;
      }
    },
  },
  created() {
    // this.getStatesList();
  },
  methods: {
    validateInput() {
      if (this.getbasicinfo.contact_num.length >= 2) {
        const fifthChar = this.getbasicinfo.contact_num[0]; // 5th character (0-indexed)
        const sixthChar = this.getbasicinfo.contact_num[1]; // 6th character (0-indexed)

        if (fifthChar == 0 || sixthChar == 0) {
          this.redcolor1 = "red";
          this.error1 = true;
          this.invalidcontact = "Invalid Contact Number";
        } else {
          this.error1 = false;
          this.redcolor1 = "";
          this.invalidcontact = "";
        }
      } else {
        this.error1 = false;
      }
    },
    validateInput1() {
      if (this.infoCard.mobileno.length >= 2) {
        const fifthChar = this.infoCard.mobileno[0]; // 5th character (0-indexed)
        const sixthChar = this.infoCard.mobileno[1]; // 6th character (0-indexed)

        if (fifthChar == 0 || sixthChar == 0) {
          this.redcolor2 = "red";
          this.error2 = true;
          this.invalidcontact2 = "Invalid Contact Number";
        } else {
          this.error2 = false;
          this.redcolor2 = "";
          this.invalidcontact2 = "";
        }
      } else {
        this.error2 = false;
      }
    },
    ConfirmSubmit() {
      if (this.checkboxTrns == true) {
        this.dialogNew1 = true;
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Please Check Terms of Service and Privacy Policy",
          color: "red",
        });
      }
    },
    dialogclose() {
      this.dialogNew1 = false;
    },

    stepper1() {
      if (this.$refs.formStep11.validate() && this.error1 == false) {
        if (this.getbasicinfo.email_id != "") {
          this.checkemailfun();
        }
      }
      // this.e1 = 2;
    },
    stepper2() {
      if (this.$refs.formStep2.validate()) {
        this.getSeletedDropdnEntity();
        this.e1 = 3;
      } else {
        this.e1 = 2;
      }
      // this.e1 = 3;
    },
    stepper3() {
      if (this.fileList == "" || this.fileList == []) {
        this.$store.commit("snackbar/showMessage", {
          content: "Please Upload Documents",
          color: "red",
        });
        this.e1 = 3;
      } else {
        this.e1 = 4;
      }
    },
    stepper4() {
      if (this.$refs.cardInfon.validate() && this.error2 == false) {
        this.e1 = 5;
      } else {
        this.e1 = 4;
      }
    },
    stepper5() {
      this.primeaccc = this.BankDetails.filter(
        (value) => value.primary_acc == 1
      ).length;
      // console.log("primeaccc", this.primeaccc);
      if (this.primeaccc == 1) {
        this.CheckAccnt();
        // this.e1 = 6;
      } else if (this.primeaccc == 0) {
        this.$store.commit("snackbar/showMessage", {
          content: "Please Select Atleast One Primary Account",
          color: "red",
        });
        this.e1 = 5;
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "You Can Have Only One Primary Account",
          color: "red",
        });
        this.e1 = 5;
      }
    },
    CheckAccnt() {
      this.e1 = 6;
    },

    stepper6() {
      this.e1 = 5;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    Addbankinfo() {
      if (this.$refs.Addbankinfonew.validate()) {
        if (this.BankDetails == undefined) {
          this.BankDetails = [];
        }
        this.$forceUpdate();

        var BankDetailsObject = {
          account_type: this.AccType,
          account_name: this.AccName,
          bank_name: this.BankName,
          bank_account_num: this.AccNo,
          primary_acc: this.primary2 == true ? 1 : 0,
        };
        this.BankDetails.push(BankDetailsObject);
        for (let i = 0; i < this.BankDetails.length; i++) {
          this.bankaccnum = this.BankDetails[i].bank_account_num;
          this.banknme = this.BankDetails[i].bank_name;
          // console.log("BankDetailsObject", this.bankaccnum);
        }
        this.create_user = false;

        this.$refs.Addbankinfonew.reset();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Please Enter CME Stage",
        };
      }
    },
    Open(item) {
      this.editedIndex = this.BankDetails.indexOf(item);
      this.editObject = Object.assign({}, item);
      this.edit_dialog = true;
      // console.log("itemssss", item);
      this.account_type = item.account_type;
      this.account_name = item.account_name;
      this.bank_name = item.bank_name;
      this.bank_account_num = item.bank_account_num;
      this.Primary = item.primary_acc;
    },

    edit() {
      if (this.$refs.editbank.validate()) {
        var BankDetailsObject = {
          account_type: this.account_type,
          account_name: this.account_name,
          bank_name: this.bank_name,
          bank_account_num: this.bank_account_num,
          primary_acc: this.Primary == true ? 1 : 0,
        };
        Object.assign(this.BankDetails[this.editedIndex], BankDetailsObject);
        this.edit_dialog = false;

        // console.log("BankDetailsObject asdasdasdasd", this.BankDetails);
      }
    },
    async checkemailfun() {
      // alert(20);
      var inputData = {
        method_name: "ADMINCORP",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "APORTAL",
        method_param: {
          action: "CHECKEMAIL",
          email_id: this.getbasicinfo.email_id,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "FAIL") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      } else {
        this.getStatesList();
        this.e1 = 2;
      }
    },
    async getStatesList() {
      // alert(20);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GSTATES",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("kkkkkk", responseData.data.data);
      this.stateList = responseData.data.data;
    },
    calladdress() {
      if (this.getaddresslist.is_bus_adrs == true) {
        this.getaddresslistbusins.addressline1 =
          this.getaddresslist.addressline1;
        this.getaddresslistbusins.addressline2 =
          this.getaddresslist.addressline2;
        this.getaddresslistbusins.city = this.getaddresslist.city;
        this.getaddresslistbusins.state = this.getaddresslist.state;
        this.getaddresslistbusins.zip_code = this.getaddresslist.zip_code;
      } else if (this.getaddresslist.is_bus_adrs == false) {
        this.getaddresslistbusins.addressline1 = "";
        this.getaddresslistbusins.addressline2 = "";
        this.getaddresslistbusins.city = "";
        this.getaddresslistbusins.state = "";
        this.getaddresslistbusins.zip_code = "";
      }
    },

    async deleteItem() {
      //console.log("this.itemForDelete.doc_id,", this.itemForDelete.doc_id);
    },
    getFileFormat(baseData) {
      const byteString = atob(baseData.split(",")[1]);
      const mimeString = baseData.split(",")[0].split(":")[1].split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    },
    getExtension(filename) {
      var i = filename.lastIndexOf(".");
      return i < 0 ? "" : filename.substr(i).replace(".", "").toLowerCase();
    },
    openImageInNewTab(url) {
      window.open(url, "_blank");
    },

    beforeaddingfile() {
      if (this.file == "" || this.documentsupload == "") {
        // this.loadingAdd = false;
        this.$store.commit("snackbar/showMessage", {
          content: "Please select document and upload a file",
          color: "red",
        });
      } else {
        this.addFile();
      }
    },
    addFile() {
      this.missingDocList = [];
      let docItem = {
        doc_name:
          this.documentsupload == "Other Documents"
            ? this.documentsuploadname
            : this.documentsupload,
        doc_url: this.file,
        docExtn: this.getExtension(this.file.name),
        fileName: this.file.name,
        size: this.file.size,
        doc_type: 1,
        doc_id: 0,
      };

      // let docIndex = this.fileList.indexOf(docItem);
      var reader = new FileReader();
      // var self = this;
      // reader.onload = (e) => {
      //   console.log("******************************")
      //   console.log(e.target)
      //   console.log("******************************")
      //   docItem.doc_url = e.target.result;
      //   self.uploadDoc(docItem);
      // };
      this.uploadDoc(docItem);
      reader.readAsDataURL(this.file);
      this.file = [];
      this.loadingAdd = false;
      // this.documentsupload = "";
      this.$refs.uploadForm.reset();
    },

    async uploadDoc(fileItem) {
      this.loader = true;
      // console.log(fileItem)
      let file = fileItem.doc_url; //this.getFileFormat(fileItem.doc_url);
      var inputData = {
        method_name: "ONUPLOAD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "UPLOAD",
          file_name: fileItem.fileName,
          doc_id: 0,
          upload_type: 8,
          // upload_type: 1,
          // corp_id: this.$store.getters.get_corpid,     for future enchancement
        },
      };

      var responseData = await apiCall(inputData, file);
      //console.log("responseData", responseData);
      // console.log(
      //   "kkkkkkkkthis.fileList[index]kkkkkkkkk",
      //   this.fileList[index]
      // );
      this.loader = false;
      if (responseData.data.status == "00") {
        this.fileList.push(fileItem);
        let docIndex = this.fileList.indexOf(fileItem);
        this.fileList[docIndex].doc_url = responseData.data.data.media_url;
        if (
          this.$store.getters.getApiCredentials.baseUrl.includes("dev") == true
        ) {
          this.fileList[docIndex].fileName = this.fileList[
            docIndex
          ].doc_url.split(
            "https://glyd-dev.s3.ap-southeast-1.amazonaws.com/CPORTAL/Common/"
          )[1];
        } else if (
          this.$store.getters.getApiCredentials.baseUrl.includes("staging") ==
          true
        ) {
          this.fileList[docIndex].fileName = this.fileList[
            docIndex
          ].doc_url.split(
            "https://glyd-stage.s3.ap-southeast-1.amazonaws.com/CPORTAL/Common/"
          )[1];
        } else if (
          this.$store.getters.getApiCredentials.baseUrl.includes("corporate") ==
          true
        ) {
          this.fileList[docIndex].fileName = this.fileList[
            docIndex
          ].doc_url.split(
            "https://glyd-prod.s3.ap-southeast-1.amazonaws.com/CPORTAL/Common/"
          )[1];
        }

        this.documentsupload = "";
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
      } else {
        // this.fileList = [];
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }
    },

    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    delet(item) {
      this.editedIndex = this.BankDetails.indexOf(item);
      this.editObject = Object.assign({}, item);
      this.dialogDelete = true;
    },
    confirmdeleteItem(item) {
      this.itemForDelete = item;
      this.indexOfItemToDelete = this.fileList.indexOf(item);

      this.confirmDeleteDialog = true;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editObject = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    deleteItemConfirm() {
      this.BankDetails.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    deleteItemFile() {
      this.fileList.splice(this.indexOfItemToDelete, 1);
      this.confirmDeleteDialog = false;
    },
    getSeletedDropdnEntity() {
      switch (this.getbasicinfo.ent_type) {
        case "Company":
        case "Partnership":
          this.documentsList = [
            "Photocopy of IC / Passport (Front & Back) of Director(s) / Partner(s) / Owner(s)",
            "SSM Company Profile Summary Document",
            "Other Documents",
          ];
          break;
        case "Society":
        case "Club":
        case "Association":
        case "Sole Proprietorship":
          this.documentsList = [
            "Photocopy of IC / Passport (Front & Back) of Director(s) / Partner(s) / Owner(s)",
            "SSM Company Profile Summary Document",
            "Certificate of Registration (Form 3 - Association)",
            "Copy of Rules & Regulation or Constitution",
            "Other Documents",
          ];
          break;
      }
    },
    async finalSubmit() {
      this.overlay = true;
      var inputData = {
        method_name: "REFSERVICE",
        page_no: null,
        record_count: 0,
        page_size: null,
        app_code: "CPORTAL",
        method_param: {
          action: "CREATECORP",
          basic_details: this.getbasicinfo,
          documents: this.fileList,
          address_details: {
            regaddress: this.getaddresslist,
            busaddress: this.getaddresslistbusins,
          },
          first_card_info: this.infoCard,
          bank_details: this.BankDetails,
          workflow_type: 1,
          pending_on: 0,
          initiated_by: this.$store.getters.get_getRefDetails.user_id,
          status: 1,
          initiated_from: 1,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
        this.dialogNew1 = false;
        this.overlay = false;
        this.$router.push("/ViewCorp");
        // this.getcountNotification();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.overlay = false;
        this.dialogNew1 = false;
      }
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
  },
};
</script>
